export default {"src":"/kaimono/_next/static/media/cn_wamazing_snow_h.0bfb827d.svg","height":116,"width":380};